import { render, staticRenderFns } from "./ResultInfo.vue?vue&type=template&id=ca76c8c0&"
import script from "./ResultInfo.vue?vue&type=script&lang=js&"
export * from "./ResultInfo.vue?vue&type=script&lang=js&"
import style0 from "./ResultInfo.vue?vue&type=style&index=0&id=ca76c8c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports